/** Fejlkode fra appserver (FOF dmoRest) i 403-svar, når en logget-ind tekniker er spærret i FOF. */
export const TEKNIKER_SPAERRET_FEJLKODE = "TEKNIKER_SPAERRET";

export const TEKNIKER_SPAERRET_BESKED = "Din adgang til ServicePro er spærret. Kontakt forsyningen.";

const MAX_INNER_ERROR_DYBDE = 5;

/**
 * True når fejlen (evt. pakket i DffError, hvis innerError ligger i params) er appserverens 403 med TEKNIKER_SPAERRET.
 * Body kan være parset JSON eller tekst, afhængigt af kaldets responseType.
 */
export function erTeknikerSpaerretFejl(error: unknown): boolean {
    let current: any = error;
    for (let dybde = 0; current && dybde < MAX_INNER_ERROR_DYBDE; dybde++) {
        if (current.status === 403 && hentFejlkode(current.error) === TEKNIKER_SPAERRET_FEJLKODE) {
            return true;
        }
        current = current.params?.innerError ?? current.innerError;
    }
    return false;
}

function hentFejlkode(body: unknown): string {
    if (!body) {
        return "";
    }
    if (typeof body === "string") {
        try {
            return hentFejlkode(JSON.parse(body));
        } catch {
            return "";
        }
    }
    const response = (body as { response?: unknown }).response;
    return typeof response === "string" ? response : "";
}
